import { Box, Checkbox, FormLabel, Stack } from "@chakra-ui/react";
import React from "react";
import CFormErrors from "./CFormErrors";
import { useEffect } from "react";
import { useState } from "react";

const CCheckbox = ({ label, name, formik, changeAction }) => {
  const orange = "orange",
    textGray = "gray";
  const errorsMsg = formik.errors[name];
  const value = formik.values[name];
  const [key, setKey] = useState(0);
  const customUncheckedIcon = (
    <span
      style={{
        borderRadius: "4px",
        backgroundColor: "#F4F4F4",
        width: "32px",
        height: "32px",
      }}
    />
  );

  useEffect(() => {
    setKey((k) => key + 1);
  }, [value]);

  const customCheckedIcon = (
    <Stack
      justifyContent="center"
      alignItems="center"
      style={{
        borderRadius: "4px",
        backgroundColor: "red",
        width: "32px",
        height: "32px",
      }}
    >
      <Box component="img" src={"icons?.checkMark"} />
    </Stack>
  );
  return (
    <Box mb="5" sx={{ mt: "auto" }}>
      <FormLabel
        control={
          <Checkbox
            lineHeight="1.25"
            alignItems="flex-start"
            fontWeight="normal"
            sx={{ "& .MuiSvgIcon-root": { fontSize: 38, color: orange } }}
            name={name}
            value={value}
            checked={value || ""}
            onBlur={formik.handleBlur}
            onChange={(e) => changeAction(e?.target?.checked)}
            icon={customUncheckedIcon} // Custom icon for unchecked state
            checkedIcon={customCheckedIcon}
          />
        }
        label={label}
        sx={{
          ".MuiFormLabel-label": {
            fontSize: "20px",
          },
        }}
      />
      <CFormErrors errorsMsg={errorsMsg} />
    </Box>
  );
};

export default CCheckbox;
